import { LoaderFunctionArgs } from 'react-router-dom'
import { protectedLoader } from './protectLoader'
import { PORTAL_ADMIN, PORTAL_SUPPORT } from '.'
import { lazyRoute } from '../utils/lazyRoute'

const supportAreasRoutes = [
  {
    path: '/support-areas',
    lazy: lazyRoute(() => import('../pages/Portal/SupportAreas')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
  {
    path: '/support-areas/:supportAreaId/users/',
    lazy: lazyRoute(
      () => import('../pages/Portal/SupportAreas/components/SupportAreaUsers'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
  {
    path: '/support-areas/:supportAreaId/customers/',
    lazy: lazyRoute(
      () =>
        import('../pages/Portal/SupportAreas/components/SupportAreaCustomers'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [PORTAL_ADMIN, PORTAL_SUPPORT],
      }),
  },
]

export default supportAreasRoutes
